module.exports = __webpack_public_path__ + "img/xuc.f667f3fb.svg";